// extracted by mini-css-extract-plugin
export default {"title":"ModalWindow_title__r-fqC","header":"ModalWindow_header__mUVD8","buttonsPanel":"ModalWindow_buttonsPanel__HCRj0"};